import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  return; // 先关闭sentry
  const router = useRouter()
  const { sentry } = useRuntimeConfig().public as any

  const globalStroe = useGlobalStore()
  const { appData }: any = storeToRefs(globalStroe)
  let sentryApi = appData.value?.externalLink?.[0]?.sentryApi;
  if(sentryApi){
    sentryApi = sentryApi.replace('https://','');
    sentryApi = sentryApi.replace('http://','');
  }
  console.log(sentryApi,'接口返回的 sentryApi');

  const domainStr = sentryApi ? sentryApi : 'stryapi.92372953.com';
  let dsnUrl = `https://914f125ad853065d12fc6df6f4f0900c@${domainStr}/11`

  // 初始化 Sentry
  Sentry.init({
    app: nuxtApp.vueApp,
    dsn: dsnUrl,
    release:import.meta.env.SENTRY_RELEASE,// 'test-9527-release'
    integrations: [
      Sentry.browserTracingIntegration({router}),
      Sentry.replayIntegration()
    ],

    environment: sentry.environment,
    
    // tracePropagationTargets: ['localhost','http://test.mediaclient-iuiu.dfre45.com'],
    tracesSampleRate: 1.0, // 性能采样率
    replaysSessionSampleRate: 0.1, // 会话回放的采样率 plugins/sentry.client.ts
    replaysOnErrorSampleRate: 1.0 // 错误采样率
  })
  window.global = window.global || {};
  window.global.sentry = Sentry;
})
